import {
  VantifyProxyResponse,
  vantifyRequest,
} from 'integrations-vantify-api-client';
import { VantifyAuth, VantifyQuery } from '../common';
import { UserListResponse, ServiceProviderListResponse } from './types';

/**
 * Get users with optional filtering and pagination
 */
export async function getUsers(
  auth: VantifyAuth,
  query?: VantifyQuery
): Promise<VantifyProxyResponse<UserListResponse>> {
  return await vantifyRequest<UserListResponse>({
    method: 'GET',
    pathname: 'users',
    query: query || {},
    auth,
  });
}

/**
 * Get service providers for a specific user
 */
export async function getServiceProviders(
  auth: VantifyAuth,
  userId: number,
  query?: VantifyQuery
): Promise<VantifyProxyResponse<ServiceProviderListResponse>> {
  const DEFAULT_LIMIT = 500;

  return await vantifyRequest<ServiceProviderListResponse>({
    method: 'GET',
    pathname: `users/${userId}/serviceproviders`,
    query: {
      limit: DEFAULT_LIMIT,
      listAll: false,
      order: 'name',
      page: 1,
      ...query
    },
    auth,
  });
}
